const isBlank = (value) => value == null || value === '';

export const getSortComparator = (isServerSorted) =>
  isServerSorted
    ? () => 0
    : (valueA, valueB, _nodeA, _nodeB, isDescending) => {
        if (isBlank(valueA) && isBlank(valueB)) return 0;
        if (isBlank(valueA)) return isDescending ? -1 : 1;
        if (isBlank(valueB)) return isDescending ? 1 : -1;
        const a = typeof valueA === 'string' ? valueA.toLowerCase() : valueA;
        const b = typeof valueB === 'string' ? valueB.toLowerCase() : valueB;
        if (a === b) return 0;
        return a > b ? 1 : -1;
      };
